
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.962 6.207L11.5 5.558 9.504 1.513a.565.565 0 00-1.009 0L6.5 5.558l-4.463.649a.561.561 0 00-.311.96l3.229 3.148-.763 4.445a.562.562 0 00.816.593L9 13.253l3.992 2.1a.562.562 0 00.816-.592l-.764-4.446 3.23-3.148a.562.562 0 00-.312-.96zm-4.276 3.665l.634 3.697L9 11.825 5.68 13.57l.634-3.696-2.686-2.62 3.712-.54L9 3.353l1.659 3.363 3.712.54-2.685 2.617z"}})])
          )
        }
      }
    